import * as React from "react";
import type { FC } from "react";
import { NetDownloadIcon16Light } from "@skbkontur/icons/NetDownloadIcon16Light";

import { ActionButtonContainer } from "./ViewFile.styles";

export const DownloadButton: FC<{ onClick: () => void }> = props => (
    <ActionButtonContainer onClick={props.onClick}>
        <NetDownloadIcon16Light />
    </ActionButtonContainer>
);
